import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { DefaultLink } from '@hivebrite/design-system/Link';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import SuccessCircleCheck from 'hb-react/shared/icons/SuccessCircleCheck';

const PasswordResetSuccess = ({ email, contact }) => {
  const { currentNetwork } = useDefaultAppContexts();

  return (
    <>
      <Title>
        <SuccessCircleCheck width="38px" />
        <Box font="h3-semibold" ml={3}>
          {__('Recovery email sent')}
        </Box>
      </Title>
      <Box mt={4}>{__('We sent a recovery email to:')}</Box>
      <Box fontWeight={2} mt={4}>
        {email}
      </Box>
      <Box font="body-asphalt-italic" display="block" mt={6}>
        {__(
          'If you did not receive any email, please contact the admin of %{network} or ',
        ).i__({
          network: currentNetwork.title,
        })}
        <DefaultLink
          display="inline"
          href={`mailto:${contact}`}
          title={contact}
        >
          {__('click here')}
        </DefaultLink>
      </Box>
    </>
  );
};

PasswordResetSuccess.propTypes = {
  email: PropTypes.string.isRequired,
  contact: PropTypes.string.isRequired,
};

export default PasswordResetSuccess;

const Title = styled(Box).attrs(() => ({
  alignItems: 'center',
  pb: 3,
}))`
  border-bottom: 1px solid ${({ theme }) => theme.colors.horizon};
`;
